"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosChainFeatures = exports.NetworkIdentifier = exports.ChainName = exports.ChainType = void 0;
var ChainType;
(function (ChainType) {
    ChainType["EVM"] = "evm";
    ChainType["COSMOS"] = "cosmos";
})(ChainType || (exports.ChainType = ChainType = {}));
var ChainName;
(function (ChainName) {
    ChainName["ARBITRUM"] = "Arbitrum";
    ChainName["ARBITRUM2"] = "arbitrum";
    ChainName["AURORA"] = "aurora";
    ChainName["AVALANCHE"] = "Avalanche";
    ChainName["BASE"] = "base";
    ChainName["BINANCE"] = "binance";
    ChainName["CELO"] = "celo";
    ChainName["CENTRIFUGE"] = "centrifuge";
    ChainName["ETHEREUM"] = "Ethereum";
    ChainName["ETHEREUM2"] = "Ethereum-2";
    ChainName["FANTOM"] = "Fantom";
    ChainName["FILECOIN"] = "filecoin";
    ChainName["FILECOIN2"] = "filecoin-2";
    ChainName["KAVA"] = "kava";
    ChainName["MANTLE"] = "mantle";
    ChainName["MOONBEAM"] = "Moonbeam";
    ChainName["OPTIMISM"] = "optimism";
    ChainName["POLYGON_ZKEVM"] = "polygon-zkevm";
    ChainName["POLYGON"] = "Polygon";
    ChainName["LINEA"] = "linea";
    ChainName["SCROLL"] = "scroll";
    // Cosmos
    ChainName["AGORIC"] = "agoric";
    ChainName["ASSETMANTLE"] = "assetmantle";
    ChainName["AURA"] = "aura";
    ChainName["AXELARNET"] = "axelarnet";
    ChainName["CARBON"] = "carbon";
    ChainName["COMDEX"] = "comdex";
    ChainName["COSMOS"] = "cosmoshub";
    ChainName["CRESCENT"] = "crescent";
    ChainName["EMONEY"] = "e-money";
    ChainName["EVMOS"] = "evmos";
    ChainName["FETCH"] = "fetch";
    ChainName["INJECTIVE"] = "injective";
    ChainName["JUNO"] = "juno";
    ChainName["KI"] = "ki";
    ChainName["KUJIRA"] = "kujira";
    ChainName["NOBLE"] = "noble";
    ChainName["OSMOSIS"] = "osmosis";
    ChainName["OSMOSIS7"] = "osmosis-7";
    ChainName["REGEN"] = "regen";
    ChainName["SEI"] = "sei";
    ChainName["SECRET"] = "secret";
    ChainName["SECRETSNIP"] = "secret-snip";
    ChainName["STARGAZE"] = "stargaze";
    ChainName["STRIDE"] = "stride";
    ChainName["TERRA2"] = "terra-2";
    ChainName["UMEE"] = "umee";
    ChainName["DYDX"] = "dydx";
})(ChainName || (exports.ChainName = ChainName = {}));
var NetworkIdentifier;
(function (NetworkIdentifier) {
    // EVM
    NetworkIdentifier["ETHEREUM"] = "Ethereum";
    NetworkIdentifier["AVALANCHE"] = "Avalanche";
    NetworkIdentifier["ARBITRUM"] = "Arbitrum";
    NetworkIdentifier["AURORA"] = "Aurora";
    NetworkIdentifier["BASE"] = "Base";
    NetworkIdentifier["BINANCE"] = "Binance";
    NetworkIdentifier["CELO"] = "Celo";
    NetworkIdentifier["FANTOM"] = "Fantom";
    NetworkIdentifier["FILECOIN"] = "Filecoin";
    NetworkIdentifier["KAVA"] = "Kava";
    NetworkIdentifier["MANTLE"] = "Mantle";
    NetworkIdentifier["MOONBEAM"] = "Moonbeam";
    NetworkIdentifier["OPTIMISM"] = "Optimism";
    NetworkIdentifier["POLYGON"] = "Polygon";
    NetworkIdentifier["LINEA"] = "Linea";
    NetworkIdentifier["SCROLL"] = "Scroll";
    // COSMOS
    NetworkIdentifier["AGORIC"] = "agoric";
    NetworkIdentifier["ASSETMANTLE"] = "assetmantle";
    NetworkIdentifier["AURA"] = "Aura";
    NetworkIdentifier["AXELAR"] = "Axelar";
    NetworkIdentifier["AXELARNET"] = "Axelarnet";
    NetworkIdentifier["CARBON"] = "Carbon";
    NetworkIdentifier["COMDEX"] = "Comdex";
    NetworkIdentifier["COSMOS"] = "Cosmoshub";
    NetworkIdentifier["CRESCENT"] = "Crescent";
    NetworkIdentifier["EMONEY"] = "E-money";
    NetworkIdentifier["EVMOS"] = "Evmos";
    NetworkIdentifier["FETCH"] = "Fetch";
    NetworkIdentifier["INJECTIVE"] = "Injective";
    NetworkIdentifier["JUNO"] = "Juno";
    NetworkIdentifier["KI"] = "Ki";
    NetworkIdentifier["KUJIRA"] = "Kujira";
    NetworkIdentifier["NOBLE"] = "Noble";
    NetworkIdentifier["OSMOSIS"] = "Osmosis";
    NetworkIdentifier["REGEN"] = "Regen";
    NetworkIdentifier["SEI"] = "Sei";
    NetworkIdentifier["SECRET"] = "Secret";
    NetworkIdentifier["SECRETSNIP"] = "Secret-snip";
    NetworkIdentifier["STARGAZE"] = "Stargaze";
    NetworkIdentifier["STRIDE"] = "Stride";
    NetworkIdentifier["TERRA2"] = "Terra-2";
    NetworkIdentifier["UMEE"] = "Umee";
    NetworkIdentifier["DYDX"] = "Dydx";
})(NetworkIdentifier || (exports.NetworkIdentifier = NetworkIdentifier = {}));
var CosmosChainFeatures;
(function (CosmosChainFeatures) {
    CosmosChainFeatures["PACKET_FORWARD_MIDDLEWARE"] = "packet-forward-middleware";
    CosmosChainFeatures["LEGACY_IBC"] = "legacy-ibc";
    CosmosChainFeatures["COSMWASM"] = "cosmwasm";
})(CosmosChainFeatures || (exports.CosmosChainFeatures = CosmosChainFeatures = {}));
//# sourceMappingURL=index.js.map